import { QueryClient } from '@tanstack/react-query'
import { INotificationContentHandler } from '@/lib/handler/notification-content-handler'
import { NotificationType } from '@/types/notification'
import { DashboardResponseType } from '@/types/dashboard'

/**
 * Users' Content Handler
 * When a new user registration notification arrives via WebSocket:
 * - Invalidates the user list if it's currently active (page is open)
 * - Increments dashboard `users.total` and `users.pendingApproval` counters
 */
export default class UsersContentHandler implements INotificationContentHandler {
  handle(_notification: NotificationType, queryClient: QueryClient): void {
    void queryClient.invalidateQueries({
      queryKey: ['users'],
      refetchType: 'active'
    })

    queryClient.setQueryData<DashboardResponseType>(['dashboard'], old => {
      if (!old?.stats) {
        return old
      }
      const currentUsers = old.stats.users
      return {
        ...old,
        stats: {
          ...old.stats,
          users: {
            total: (currentUsers?.total ?? 0) + 1,
            pendingApproval: (currentUsers?.pendingApproval ?? 0) + 1
          }
        }
      }
    })
  }
}
